"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Interstitial = exports.ClerkProvider = void 0;
const tslib_1 = require("tslib");
const clerk_react_1 = require("@clerk/clerk-react");
const gatsby_1 = require("gatsby");
const react_1 = tslib_1.__importDefault(require("react"));
(0, clerk_react_1.__internal__setErrorThrowerOptions)({ packageName: 'gatsby-plugin-clerk' });
function ClerkProvider({ children, ...rest }) {
    const { clerkState, ...restProps } = rest;
    const { __clerk_ssr_state, __clerk_ssr_interstitial_html } = clerkState?.__internal_clerk_state || {};
    return (react_1.default.createElement(clerk_react_1.ClerkProvider, { navigate: to => (0, gatsby_1.navigate)(to), initialState: __clerk_ssr_state || {}, ...restProps }, __clerk_ssr_interstitial_html ? (react_1.default.createElement(clerk_react_1.ClerkLoaded, null,
        react_1.default.createElement(Interstitial, { html: __clerk_ssr_interstitial_html }))) : (children)));
}
exports.ClerkProvider = ClerkProvider;
function Interstitial({ html }) {
    return react_1.default.createElement("html", { dangerouslySetInnerHTML: { __html: html } });
}
exports.Interstitial = Interstitial;
